/**
 * Format a date string to a human-readable format in the user's timezone.
 *
 * @param {string} dateString - ISO date string
 * @param {string} [timezone] - IANA timezone (defaults to 'UTC')
 * @param {'full'|'short'} [format='full'] - 'short' for date-only, 'full' for date + time
 * @returns {string}
 */
export const formatToAccountTime = (dateString, timezone, format = 'full') => {
  if (!dateString) return 'N/A';

  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return 'Invalid Date';

    const tz = timezone || 'UTC';

    if (format === 'short') {
      return date.toLocaleDateString('en-US', {
        timeZone: tz,
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      });
    }

    // Default: full format with time
    return date.toLocaleString('en-US', {
      timeZone: tz,
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });
  } catch (error) {
    console.error('Date formatting error:', error);
    return 'Invalid Date';
  }
};
